import { render, staticRenderFns } from "./ReportStudent.vue?vue&type=template&id=b3b7ce1e"
import script from "./ReportStudent.vue?vue&type=script&lang=js"
export * from "./ReportStudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports